import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../service/apiService";
import logo from "../assets/logo.png";

function LoginPage({ setUser }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await loginUser(username, password);
      if (res.status === "success") {
        localStorage.setItem("user", JSON.stringify(res.user));

        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
        }

        setUser(res.user);
      } else {
        setError(res.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Server error. Please try again later.");
    }
  };

  return (
    <Container fluid className="vh-100 d-flex align-items-center justify-content-center bg-light">
      <Row className="w-100 justify-content-center">
        <Col xs={11} sm={8} md={6} lg={4}>
          <Card className="shadow border-0">
            <Card.Body className="p-4 p-md-5">

              {/* Logo & Title */}
              <div className="text-center mb-4">
                <img src={logo} alt="Logo" height="52" className="mb-3" />
                <h4 className="fw-bold mb-1">Admin Login</h4>
                <small className="text-muted">
                  Authorized personnel only
                </small>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                {/* Correctly styled checkbox */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Form.Check
                    type="switch"
                    id="rememberMe"
                    label="Remember me"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />

                  <Button
                    variant="link"
                    className="p-0 text-decoration-none"
                    onClick={() => navigate("/forgot-password")}
                  >
                    Forgot password?
                  </Button>
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 py-2"
                >
                  Login
                </Button>
              </Form>

            </Card.Body>
          </Card>

          <p className="text-center text-muted mt-3 small">
            © {new Date().getFullYear()} Semicolon Innovations
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default LoginPage;
